"use client";
import useDeviceDetection from "@/libs/hooks/useDeviceDetection";
import {Image} from "@nextui-org/react";
import type {NextPage} from "next";
import {Cover} from "../cover/cover";
import {LoginForm} from "./login.form";

export const Login: NextPage = function () {
  const {isMobile, isDesktopModeOnMobile} = useDeviceDetection();
  if (isMobile && !isDesktopModeOnMobile) {
    return (
      <div className="flex w-screen flex-col items-center justify-between bg-[url('/images/Group.svg')] bg-cover bg-no-repeat px-6 py-8 text-center">
        <div>
          <h1 className="mb-2 text-2xl font-extrabold text-black">
            Get the NeoTrack App
          </h1>
          <p className="text-md mt-4 text-gray-800">
            For the best experience, download our mobile app
          </p>
        </div>
        <div className="relative mt-2 flex items-center justify-center gap-4">
          <img
            src="/images/mobileapp.svg"
            alt="Phone Map"
            className="z-10 w-44 rounded-xl sm:w-52 md:w-56"
          />
        </div>
        <h2 className="mt-2 text-lg font-extrabold text-black">Download Now</h2>
        <div className="">
          <a
            href="https://play.google.com/store/apps/details?id=com.neotrack.app"
            className="mx-auto flex w-full max-w-xs items-center justify-center gap-3 py-1"
            target="_blank"
          >
            <img
              src="/images/googleplay.svg"
              alt="Google Play"
              className="w-auto"
            />
          </a>

          <a
            href="https://apps.apple.com/gr/app/neotrack-school-bus-tracking/id1021175109"
            className="mx-auto flex w-full max-w-xs items-center justify-center gap-3 py-1"
            target="_blank"
          >
            <img
              src="/images/applestore.svg"
              alt="App Store"
              className="w-auto"
            />
          </a>

          <p className="text-sm text-gray-600">
            or
            <br />
            <span className="font-medium text-black">
              Manually switch to desktop site on your mobile browser
            </span>
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex h-screen w-full">
      <Cover />
      <div className="relative flex h-screen w-1/2 flex-col items-center justify-center bg-white">
        <div className="flex w-full  flex-col justify-center">
          <div className="flex justify-center">
            <Image
              src="/images/logo.svg"
              alt="Neo Track"
              width={325}
              height={150}
            />
          </div>
          <div className="mt-2 flex w-full p-5">
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};
